<template>
  <a class="text -t2 -download" :href="file.url">{{ linkText }}</a>
</template>

<script>
  export default {
    props: {
      file: Object,
      linkText: String
    }
  }
</script>

<style lang="scss" scoped>
  .text {
    display: inline-block;
    margin-bottom: 1.2em;
  }
</style>
